import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import showAlert from 'utils/showAlert';

export default function DeleteAccount(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // To handle button state during deletion

  const showModal = () => setIsModalVisible(true);
  const hideModal = () => setIsModalVisible(false);

  const deleteUser = async (event) => {
    event.preventDefault();
    setIsDeleting(true);

    try {
      const response = await fetch('/datapulse/users/destroy-self', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      });

      console.log(response);

      if (response.ok) {
        const data = await response.json();
        showAlert('Your account has been deleted successfully.', 'success');
        window.location.href = '/datapulse/login'; // Redirect to home page
      } else {
        showAlert('Failed to delete your account. Please try again later.', 'danger');
      }
    } catch (error) {
      showAlert('An error occurred while deleting your account. Please try again later.', 'danger');
    } finally {
      setIsDeleting(false);
      hideModal();
    }
  };

  return (
    <>
      <div>
        <div className="delete-account">
          <button type="button" className="button b-size-normal btn-danger" onClick={showModal}>
            Delete your account
          </button>
        </div>
        <Modal show={isModalVisible} onHide={hideModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4>Delete your DataPulse account</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p className="mb-4">Are you sure you want to permanently delete your account? This action is not reversible.</p>
              <button className="lite-btn btn-default mr-3" onClick={hideModal} disabled={isDeleting}>
                Cancel
              </button>
              <button className="lite-btn btn-danger" onClick={deleteUser} disabled={isDeleting}>
                {isDeleting ? 'Deleting...' : 'Confirm'}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
